import type { CreateConnectorFn } from 'wagmi'
import { createConnector } from 'wagmi'
import { injected } from 'wagmi/connectors'

import { getExplicitInjectedProvider } from './explicit-injected-provider-registry'

export * from './explicit-injected-provider-registry'

export const EXPLICIT_INJECTED_CONNECTOR_TYPE = 'explicitInjected'

export function hasExplicitInjectedConnector(connectors: readonly { type: string }[]): boolean {
  return connectors.some(connector => connector.type === EXPLICIT_INJECTED_CONNECTOR_TYPE)
}

/**
 * Build one injected connector pinned to the provider registry above.
 *
 * Unlike Wagmi's default injected connector, this never reads `window.ethereum` and never scans
 * EIP-6963 announcements. It is useful whenever the caller must choose the only permitted wallet.
 */
export function explicitInjectedConnector(): CreateConnectorFn {
  const connector = injected({
    shimDisconnect: false,
    target: {
      id: 'explicitInjected',
      name: 'Browser wallet',
      provider: getExplicitInjectedProvider
    }
  })

  return createConnector(config => ({
    ...connector(config),
    // AppKit treats every non-basic connector with type `injected` as EIP-6963 discovery and
    // filters it when `enableEIP6963` is false. Give this caller-owned connector its own type so
    // discovery can stay disabled while the one selected provider remains connectable.
    type: EXPLICIT_INJECTED_CONNECTOR_TYPE
  }))
}
